<button class="btn btn-ms-secondary dropdown-toggle" data-bs-toggle="dropdown">
    <fa-duotone-icon icon="bars-sort" secondaryOpacity="0.9" class="fs-6 d-none d-sm-inline" />
    Sort
</button>

<ul class="dropdown-menu dropdown-menu-end sort-drop-down-list py-0">
    @for (option of sortOptions(); track $index) {
        <li>
            <h6 class="dropdown-header mt-2 mb-0 pb-0 fw-bold">{{option.label}}</h6>
        </li>
        <li>
            <a class="dropdown-item d-flex align-items-center" (click)="onSortChange(convertSortOptionArrayToString(option.value, true))"
                role="button">
                    <span class="ms-3 me-auto">Ascending</span>
                    @if (selectedSortOption() == convertSortOptionArrayToString(option.value, true)) {
                        <fa-duotone-icon icon="check" class="ms-2" secondaryOpacity="0.9" />
                    }
            </a>
        </li>
        <li>
            <a class="dropdown-item d-flex align-items-center" (click)="onSortChange(convertSortOptionArrayToString(option.value, false))"
                role="button">
                    <span class="ms-3 me-auto">Descending</span>
                    @if (selectedSortOption() == convertSortOptionArrayToString(option.value, false)) {
                        <fa-duotone-icon icon="check" class="ms-2" secondaryOpacity="0.9" />
                    }
            </a>
        </li>
    }
</ul>